export default "__VITE_ASSET__c62dced8__"